import React, { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import axios from "axios";
import { GET_ALL_EMAILS, RESEND_EMAIL } from "../../api/emailTracking";
import { Button } from "@mui/material";

function EmailDataGrid() {
  const [rows, setRows] = useState([]);
  const [refresh, setRefresh] = useState(false);

  const handleResendEmail = async (row) => {
    try {
      axios
        .post(RESEND_EMAIL, {
          to: row.email,
          subject: row.subject,
          htmlContent: row.htmlContent,
          attachments: row.attachments5,
        })
        .then((res) => {
          console.log(res);
          setRefresh(true);
          alert("Email sent successfully");
        });
    } catch (error) {
      console.error("Error resending email", error);
      alert("Error resending email");
    }
  };

  const columns = [
    { field: "email", headerName: "Email", width: 200 },
    { field: "subject", headerName: "Subject", width: 300 },
    {
      field: "opened",
      headerName: "Opened",
      width: 100,
      renderCell: (params) => (params.value ? "Yes" : "No"),
    },
    {
      field: "sentAt",
      headerName: "Sent At",
      width: 200,
      valueFormatter: (params) =>
        params.value ? new Date(params.value).toLocaleString() : "",
    },
    {
      field: "openedAt",
      headerName: "Opened At",
      width: 200,
      valueFormatter: (params) =>
        params.value ? new Date(params.value).toLocaleString() : "",
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 150,
      renderCell: (params) => (
        <Button onClick={() => handleResendEmail(params.row)}>
          Resend Email
        </Button>
      ),
    },
  ];

  useEffect(() => {
    axios
      .get(GET_ALL_EMAILS)
      .then((response) => {
        // Ensure DataGrid gets an id field - use _id from MongoDB
        const emails = response.data.map((email) => ({
          ...email,
          id: email._id,
        }));
        setRows(emails);
        setRefresh(false);
      })
      .catch((error) => {
        console.error("Error fetching emails", error);
      });
  }, [refresh]);

  return (
    <div style={{ width: "100%", height: "100vh" }}>
      <h1>Email Tracking</h1>
      <DataGrid rows={rows} columns={columns} pageSize={10} />
    </div>
  );
}

export default EmailDataGrid;
